import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import { handleFileDownload } from "../utils/fileDownloadHelper";
import env from "../environment/env.json";

export interface CustomerUpload {
  /** TODO: Fill with attributes */
  placeholder: string;
}

export class CustomerUploadService {
  private httpClient = makeHttpClient();

  getAll(customer_id: any, specific: any, query: any) {
    let url = `${env.customerUrl}customer-upload/?`;
    if (specific) {
      url = `${url}&specific=True`;
    }

    if (customer_id) {
      url = `${url}&customer_name=${customer_id}`;
    }

    if (query) {
      url = `${url}&${query}`;
    }

    return _unwrapAxiosResponse(this.httpClient.get(url));
  }
  create(form: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };

    const data = new FormData();
    data.append("id", form.id);
    data.append("customer_id", form.customer);
    data.append("country", form.country);
    data.append("stream", form.stream);
    data.append("period", form.period);
    data.append("comments", form.comment);
    const documents = form.document;
    if (documents) {
      for (let i = 0; i < documents.length; i++) {
        data.append("document" + i, documents[i]);
      }
    }

    return _unwrapAxiosResponse(
      this.httpClient.post<CustomerUpload>(
        env.customerUrl + "customer-upload/",
        data,
        headers
      )
    );
  }
  update(form: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    const data = new FormData();
    data.append("id", form.id);
    data.append("customer_id", form.customer);
    data.append("country", form.country);
    data.append("stream", form.stream);
    data.append("period", form.period);
    data.append("comments", form.comment);
    data.append("document", form.document);
    data.append("docToReplace", form.docToReplace);

    return _unwrapAxiosResponse(
      this.httpClient.put<CustomerUpload>(
        env.customerUrl + "customer-upload/",
        data,
        headers
      )
    );
  }
  exportCustomerUpload(id: number, fileName: string, customerID: number) {
    const url = `${
      env.customerUrl
    }export-customer-upload/?id=${id}&upload=${encodeURIComponent(
      fileName
    )}&customer_id=${customerID}`;

    return handleFileDownload(
      this.httpClient,
      url,
      fileName,
      "Export not possible",
      "There was an error exporting customer upload. Please contact your Customer Account Manager."
    );
  }
  getCustomerUploadUsers(customer_name: any) {
    const url = `${env.customerUrl}upload/users/?customer_name=${customer_name}`;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }
}

export default CustomerUploadService;
